export const calcularNivelLiderazgo = (puntuacion) => {
  if (puntuacion === null || puntuacion === undefined) return 'Sin evaluar';
  if (puntuacion <= 20) return 'Liderazgo en desarrollo';
  if (puntuacion <= 40) return 'Liderazgo intermedio';
  if (puntuacion <= 50) return 'Liderazgo avanzado';
  if (puntuacion <= 80) return 'Liderazgo experto';
  return 'Liderazgo transformacional';
};
